import { Box, Button, Flex, Grid, Input, Text } from "@mantine/core";
import { IconSearch, IconTimeDuration15 } from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { _localization } from "../../../config/location";
// import { SelectListItemModel } from "../../../model/SelectListItem";
import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import BreadCrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import Repository from "../../../_base/helper/HttpHelper";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../../common/FormatDate/FormatDate";
import { API_ROUTE } from "../../../const/apiRoute";
import { SelectListItemModel } from "../../../model/SelectListItem copy";
import { useLocation } from "react-router-dom";
const CustommerReviewList = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [data, setData] = useState<CustomerQuestion[]>([]);
  const [dataInvCode, setDataInvCode] = useState<SelectListItemModel[]>([]);
  const [dataItemCode, setDataItemCode] = useState<SelectListItemModel[]>([]);
  const [dataSaleChannel, setDataBranchCode] = useState<SelectListItemModel[]>(
    []
  );
  const [visible, { toggle, close, open }] = useDisclosure(false);

  const sizeGrid = { base: 6, sm: 6, md: 4, lg: 4, xl: 2 };
  const [rowCount, setRowCount] = useState(0);

  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  const formSeachInput = useForm({
    mode: "uncontrolled",
    initialValues: {
      KeySearch: _searchJson && checkedPinSearch ? _searchJson?.KeySearch : "",
      StartDate: _searchJson && checkedPinSearch ? _searchJson?.StartDate : "",
      EndDate: _searchJson && checkedPinSearch ? _searchJson?.EndDate : "",
      CustomerEmail: "",
      StatusComment: "",
      CustomerTel: "",
    },
  });

  type CustomerQuestion = {
    id: string;
    title: string;
    content: string;
    createTime: string; // ISO Date string
    customerEmail: string;
    customerName: string;
    customerIp: string;
    rating: number;
    isFeatured: boolean;
    status: boolean;
    statusComment: string;
    lastUpdate: string; // ISO Date string
    lastUpdateBy: string;
    voteFor: number;
    voteAgainst: number;
    peopleVote: string | null;
    customerTel: string;
    customerAddress: string;
  };
  const formatNumber = (number: number) => {
    return new Intl.NumberFormat("vi-VN", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(number);
  };
  const calculateDaysDifference = (date: string) => {
    const now = new Date();
    const pastDate = new Date(date);
    const differenceInTime = now.getTime() - pastDate.getTime();
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);
    return formatNumber(differenceInDays);
  };
  const columns = React.useMemo<MRT_ColumnDef<CustomerQuestion>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 50,
      },

      {
        accessorKey: "customerName",
        header: "Họ tên",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "customerTel",
        header: "Số điện thoại",
        size: 140,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "customerEmail",
        header: "Email",
        size: 250,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "customerAddress",
        header: "Địa chỉ",
        size: 150,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      // {
      //     accessorKey: "other",
      //     header: "Khác",
      //     size: 150,
      //     Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      // },
      {
        accessorKey: "title",
        header: "Tiêu đề",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "content",
        header: "Nội dung",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
        size: 400,
      },
      {
        accessorKey: "customerIp",
        header: "IP",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
        size: 100,
      },
      {
        accessorKey: "createTime",
        header: "Ngày mua",
        Cell: ({ renderedCellValue }: any) => (
          <Text size="sm">
            {renderedCellValue && formatDateTransfer(renderedCellValue)}
          </Text>
        ),
      },
      {
        accessorKey: "rating",
        header: "Đánh giá",
        size: 150,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      // {
      //     accessorKey: "isValid",
      //     header: "Trạng thái",
      //     size: 150,
      //     Cell: ({ renderedCellValue }) => (
      //         <Badge
      //             color={renderedCellValue ? "green" : "red"}
      //             variant="light"
      //         >
      //             {renderedCellValue ? "Hợp lệ" : "Không hợp lệ"}
      //         </Badge>
      //     ),
      // },
    ],
    []
  ); // Hàm lấy dữ liệu
  const fetchData = async () => {
    setIsLoading(true);
    setData([]);
    setIsError(false);

    try {
      const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
      const queryParams = new URLSearchParams();

      queryParams.append(
        "Skip",
        String(pagination.pageIndex * pagination.pageSize)
      );
      queryParams.append("Take", String(pagination.pageSize));

      // Thêm các tham số tìm kiếm nếu có
      const searchValues = formSeachInput.getValues();
      if (searchValues.KeySearch?.trim()) {
        queryParams.append("KeySearch", searchValues.KeySearch);
      }

      if (searchValues.StartDate) {
        queryParams.append(
          "StartDate",
          formatDateNotTimeZone(searchValues.StartDate)
        );
      }

      if (searchValues.EndDate) {
        queryParams.append(
          "EndDate",
          formatDateNotTimeZone(searchValues.EndDate)
        );
      }

      // Tạo URL với query params
      const url = `${API_ROUTE.SALLER_REVIEW}?${queryParams.toString()}`;

      const response = await repository.get(url);

      if (response && response.data) {
        setData(response.data);
        setRowCount(response.totalCount || 0);
      } else {
        setData([]);
        setRowCount(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsError(true);
      NotificationExtension.Warn("Có lỗi xảy ra khi tải dữ liệu!");
    } finally {
      setIsLoading(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify(formSeachInput.getValues())
      );
    }
  };

  useEffect(() => {
    // Gọi hàm fetchData khi component mount
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize]);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,

    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT", "orderNumber"],
        right: ["action"],
      },
      columnVisibility: { id: true },
      density: "xs",
    },
    enableRowSelection: false,
    mantineTableContainerProps: {
      style: { maxHeight: height - 100, minHeight: height - 100 },
    },
    enableStickyHeader: true,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "550",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      pagination,
    },
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (130 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, [pagination]);
  return (
    <>
      <Flex
        justify="space-between"
        align="center"
        style={{
          border: "1px solid #dee2e6",
          padding: "5px 10px",
        }}
      >
        <BreadCrumb />
      </Flex>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
          // marginTop: "10px",
        }}
      >
        <Grid style={{ width: "100%" }} mt={10}>
          <Grid.Col span={sizeGrid}>
            <Input
              size="sm"
              placeholder="Từ khoá"
              type="text"
              leftSection={<IconSearch color="#15aabf" />}
              key={formSeachInput.key("KeySearch")}
              {...formSeachInput.getInputProps("KeySearch")}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>{" "}
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày bắt đầu"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              value={
                formSeachInput.getValues()?.StartDate &&
                formSeachInput.getValues()?.StartDate?.length > 0
                  ? new Date(formSeachInput.getValues()?.StartDate)
                  : null
              }
              onChange={(date) => {
                formSeachInput.setValues((prev) => ({
                  ...prev,
                  StartDate: date ? formatDateNotTimeZone(date) : "",
                }));
              }}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày kết thúc"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
              value={
                formSeachInput.getValues()?.EndDate &&
                formSeachInput.getValues()?.EndDate?.length > 0
                  ? new Date(formSeachInput.getValues()?.EndDate)
                  : null
              }
              onChange={(date) => {
                formSeachInput.setValues((prev) => ({
                  ...prev,
                  EndDate: date ? formatDateNotTimeZone(date) : "",
                }));
              }}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Button
              type="submit"
              leftSection={<IconSearch size={20} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>{" "}
          </Grid.Col>
        </Grid>
      </Box>

      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default CustommerReviewList;
